import React from 'react';
import { useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';
import { parseRange, getRangeTicks, parseSliderAnswer, buildSliderAnswer } from '../EvaluationScaleConfig';

const SemanticDiffPreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();
  const disabled = !sendSurvey || outOfDate;

  const choices = question.questionChoicesAttributes || [];
  const configChoice = choices.find(c => c.kind === 'config');
  const range = configChoice?.label || '-3a3';
  const { min, max } = parseRange(range);
  const ticks = getRangeTicks(range);

  const leftChoices = choices.filter(c => c.kind === 'left' && !c._destroy).sort((a, b) => a.position - b.position);

  const rightChoices = choices.filter(c => c.kind === 'right' && !c._destroy);

  const currentAnswerText =
    values?.employeeSurvey?.employeeQuestionChoicesAttributes?.find?.(eqc => eqc?.questionId === question.id)
      ?.answerText || '';

  const parsedSliderValues = parseSliderAnswer(currentAnswerText);

  const handleChange = (rowPosition, val) => {
    if (disabled) return;
    const updated = { ...parsedSliderValues, [rowPosition]: parseInt(val, 10) };
    setFieldValue(`${fieldName}[answerText]`, buildSliderAnswer(updated));
  };

  return (
    <div className="mt-2">
      {leftChoices.map(leftChoice => {
        const rightChoice = rightChoices.find(r => r.position === leftChoice.position);
        const currentVal = parsedSliderValues[leftChoice.position] ?? 0;

        return (
          <div key={leftChoice.id || leftChoice.position} className="eval-semantic-preview-row">
            <div className="eval-semantic-preview-label eval-semantic-preview-label--left">
              {leftChoice.label || ''}
            </div>
            <div className="eval-semantic-scale-wrapper">
              <div className="eval-semantic-ticks">
                {ticks.map(t => (
                  <span key={t}>{t}</span>
                ))}
              </div>
              <Form.Control
                type="range"
                min={min}
                max={max}
                value={currentVal}
                step={1}
                disabled={disabled}
                onChange={e => handleChange(leftChoice.position, e.target.value)}
                className="eval-semantic-preview-slider"
              />
            </div>
            <div className="eval-semantic-preview-label eval-semantic-preview-label--right">
              {rightChoice?.label || ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SemanticDiffPreview;
